module.exports = __webpack_public_path__ + "img/zag.33632a43.svg";